// extracted by mini-css-extract-plugin
export var chevronIcon = "_4x-2";
export var teamName = "_4x-1";
export var teamSwitcherButton = "_4x-0";